module.exports = __webpack_public_path__ + "static/media/image2.a4c0bd05.jpeg";